var _rect, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "url(#pattern0_1224_1398)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_1224_1398",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_1224_1398",
    transform: "scale(0.0625)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_1224_1398",
    width: 16,
    height: 16,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAAXNSR0IArs4c6QAAAbFJREFUOE99Uz1rG0EQndk7dYHgNAbjwqRIGQx2a+M/ELs3CRi0O4sEcaFfYFIGI9sKSOwcgoNAett/wJAmJDGOU6QMLkOKhIAqfeyEO07mtD5pi927fTtv35uZRQhGvV5/EsfxgYjsAcB2Af8AgIvhcHiWpumvcgiWf4hoHwCORYQQ8SMz/8twInosIluIyABwysxvp3H3BEQkIvIuSZLDUFVwyQUAvGDmPDafrLUt7/1aGExERxnOzPk6HUR0AgDCzC3UWi8rpW6YeSW8eR5BYevKe/8SrbV1APjtnLsMCay1m9mec+5riGmtt6IoeoZEdBtF0U6v1/tboeBbYWE9xBqNxtJkMkkzgszLTDVKXqUgmIcPFhJYa3PpzrncSoXCARpjbuM4rrSwiKBs4Q0ifpmTxLkK7pOotV5VSn2uKuMiBUT0yXu/lyeHiNoiElc00s8iiU/L/o0xHaXUnXOuPdPKAHDJzLvTw8aYV9l3kiTvS3sdRHw908qlsmWP6VBEWrVa7Xu32x1kWLPZfDQajZ4jYhsAOsz8YRrzoL7Bc94oDl4j4vl4PE77/f6fsp3/0sLU3urVq60AAAAASUVORK5CYII="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.71e6a06e5a2b20f39e9ac1b273cd8456.svg";
export { ForwardRef as ReactComponent };